// extracted by mini-css-extract-plugin
export default {"Prehled":"Prehled_Prehled__Hu5yt","Menu":"Prehled_Menu__GUew0","Obsah":"Prehled_Obsah__TAD9C","Button_Active":"Prehled_Button_Active__MlKRD"};